(() => {
    const STORAGE_KEY = 'sf_wishlist_v1';

    function getStorefrontRoot() {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            return window.Shopify.routes.root;
        }

        return '/';
    }

    function getWishlist() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        } catch (e) {
            return [];
        }
    }

    function saveWishlist(list) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(list.map(({ cardHtml, ...item }) => item)));
        } catch (e) {
            // ignore
        }
    }

    function findItem(handle) {
        return getWishlist().find(i => i.handle === handle);
    }

    async function getLiveWishlistItem(item) {
        if (!item || !item.handle) return null;

        try {
            const url = new URL(getStorefrontRoot() + 'products/' + encodeURIComponent(item.handle), window.location.origin);
            url.searchParams.set('section_id', 'wishlist-product-card');
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) return null;
            const html = await response.text();
            const document = new DOMParser().parseFromString(html, 'text/html');
            const card = document.querySelector('.sf-product-card[data-product-id]');
            if (!card || !card.dataset.productId) return null;
            return { ...item, cardHtml: card.outerHTML };
        } catch (e) {
            return null;
        }
    }

    async function getValidWishlist(list) {
        const resolved = await Promise.all(list.map(getLiveWishlistItem));
        const validList = resolved.filter(Boolean);

        if (validList.length !== list.length) {
            saveWishlist(validList);
            updateWishlistBadge();
        }

        return validList;
    }

    function addItem(item) {
        const list = getWishlist();
        if (!list.find(i => i.handle === item.handle)) {
            list.push(item);
            saveWishlist(list);
            updateWishlistBadge();
        }
    }

    function removeItem(handle) {
        const list = getWishlist().filter(i => i.handle !== handle);
        saveWishlist(list);
        updateWishlistBadge();
    }

    function updateWishlistBadge() {
        const count = getWishlist().length;
        document.querySelectorAll('.header-wishlist-count').forEach(badge => {
            if (count > 0) {
                badge.textContent = count;
                badge.hidden = false;
            } else {
                badge.textContent = '0';
                badge.hidden = true;
            }
        });
    }

    function initProductButtons() {
        document.querySelectorAll('.save-to-wishlist').forEach((btn) => {
            const handle = btn.dataset.wishlistHandle;
            if (!handle) return;

            function updateState() {
                const exists = !!findItem(handle);
                if (exists) {
                    btn.textContent = 'Go to wishlist';
                    btn.classList.add('is-wishlisted');
                    if (btn.dataset.wishlistEraClass) {
                        btn.classList.add(btn.dataset.wishlistEraClass);
                    }
                } else {
                    btn.textContent = 'Save to wishlist';
                    btn.classList.remove('is-wishlisted');
                    if (btn.dataset.wishlistEraClass) {
                        btn.classList.remove(btn.dataset.wishlistEraClass);
                    }
                }
            }

            updateState();

            btn.addEventListener('click', (e) => {
                const exists = !!findItem(handle);
                if (exists) {
                    // go to wishlist
                    window.location.href = '/pages/wishlist';
                    return;
                }

                // collect product data from data- attributes
                const item = {
                    handle: handle,
                    title: btn.dataset.wishlistTitle || '',
                    url: btn.dataset.wishlistUrl || window.location.pathname,
                    image: btn.dataset.wishlistImage || '',
                    price: btn.dataset.wishlistPrice || ''
                };

                addItem(item);
                updateState();
            });
        });
    }

    async function renderWishlistGrid(container, list) {
        const items = list || await getValidWishlist(getWishlist());
        container.innerHTML = '';
        if (!items.length) {
            const page = document.querySelector('.wishlist-page');
            const footer = document.querySelector('.wishlist-footer');
            if (page) page.classList.add('is-empty');
            if (footer) footer.hidden = true;

            container.innerHTML = `
                <div class="empty-wishlist card-color">
                    <p class="label-sm uppercase active-era-text">Wishlist empty</p>
                    <h2 class="uppercase">Your wishlist is empty.</h2>
                    <p class="muted-text body-sm">Save products here and come back when you're ready.</p>
                    <a href="/collections/core-collection" class="button button-filled active-era-background">Browse core collection</a>
        </div>`;
            return;
        }

        const page = document.querySelector('.wishlist-page');
        const footer = document.querySelector('.wishlist-footer');
        if (page) page.classList.remove('is-empty');
        if (footer) footer.hidden = false;

        const grid = document.createElement('div');
        grid.className = 'product-grid';
                items.forEach(item => {
            const template = document.createElement('template');
            template.innerHTML = item.cardHtml;
            const card = template.content.firstElementChild;
            if (!card) return;
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'button-muted remove-from-wishlist';
            remove.dataset.handle = item.handle;
            remove.textContent = 'Remove';
            card.appendChild(remove);
            grid.appendChild(card);
        });

        container.appendChild(grid);

        // bind remove buttons
        container.querySelectorAll('.remove-from-wishlist').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const handle = btn.dataset.handle;
                removeItem(handle);
                renderWishlistGrid(container);
                // also update product page buttons if present
                document.querySelectorAll('.save-to-wishlist').forEach(pbtn => {
                    if (pbtn.dataset.wishlistHandle === handle) {
                        pbtn.textContent = 'Save to wishlist';
                        pbtn.classList.remove('is-wishlisted');
                        if (pbtn.dataset.wishlistEraClass) {
                            pbtn.classList.remove(pbtn.dataset.wishlistEraClass);
                        }
                    }
                });
            });
        });
    }

    function initWishlistPage(list) {
        const container = document.getElementById('wishlist-items');
        if (!container) return;
        renderWishlistGrid(container, list);
    }

    async function bootstrapWishlist() {
        const list = await getValidWishlist(getWishlist());
        initProductButtons();
        initWishlistPage(list);
        updateWishlistBadge();
    }

    document.addEventListener('DOMContentLoaded', () => {
        bootstrapWishlist();
    });

})();
